


export type FlowRoleAssignmentHolderKind = 'Private' | 'RoleGroup';

export const FlowRoleAssignmentHolderKind = {
    Private: 'Private' as FlowRoleAssignmentHolderKind,
    RoleGroup: 'RoleGroup' as FlowRoleAssignmentHolderKind
};

